module.exports = __webpack_public_path__ + "img/dy.78c72a92.jpg";